import React, { useEffect, useState } from "react";
import { ref, onValue, get } from "firebase/database";
import { db } from "../../firebase";
import { useNavigate } from "react-router-dom";
import "./AdmissionVideos.css";
import "../counsellingPage/CounselingHome.css"; // popup css

const AdmissionVideos = () => {

  const [videos, setVideos] = useState([]);
  const [premium, setPremium] = useState(false);
  const [showPremium, setShowPremium] = useState(false);

  const navigate = useNavigate();

  // ================= CHECK PREMIUM =================

  useEffect(() => {

    const uid = localStorage.getItem("uid");

    if (!uid) {
      setPremium(false);
      return;
    }

    get(ref(db, "users/" + uid))
      .then((snap) => {
        if (snap.exists()) {
          setPremium(snap.val().is_premium === true);
        }
      });

  }, []);

  // ================= DRIVE CDN FIX =================

  const getThumbnail = (videoUrl, thumbUrl) => {

    if (thumbUrl && thumbUrl.includes("drive.google.com")) {

      let fileId = "";

      const match1 = thumbUrl.match(/\/d\/([a-zA-Z0-9_-]+)/);
      const match2 = thumbUrl.match(/[?&]id=([a-zA-Z0-9_-]+)/);

      if (match1) fileId = match1[1];
      else if (match2) fileId = match2[1];

      if (fileId) {
        return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;

      }
    }

    if (thumbUrl) return thumbUrl;

    if (videoUrl && (videoUrl.includes("youtube") || videoUrl.includes("youtu.be"))) {

      let id = "";

      if (videoUrl.includes("watch?v="))
        id = videoUrl.split("watch?v=")[1].split("&")[0];
      else if (videoUrl.includes("youtu.be/"))
        id = videoUrl.split("youtu.be/")[1];

      if (id) {
        return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
      }
    }

    return "";
  };

  // ================= FIREBASE FETCH =================

  useEffect(() => {

    const refData = ref(db, "videos/counselling");

    onValue(refData, (snap) => {

      const data = snap.val();

      if (!data) {
        setVideos([]);
        return;
      }

      const formatted = Object.keys(data).map(id => {

        const v = data[id];

        return {
          id,
          title: v.title || "No Title",
          videoUrl: v.videoUrl || v.vimeoUrl,
          thumbnailUrl: getThumbnail(
            v.videoUrl || v.vimeoUrl,
            v.thumbnailUrl
          )
        };

      });

      setVideos(formatted);

    });

  }, []);

  // ================= OPEN VIDEO =================

  const openVideo = (url) => {

    if (!url) return;

    // 🔒 BLOCK FREE USERS
    if (!premium) {
      setShowPremium(true);
      return;
    }

    navigate("/player", {
      state: { url }
    });
  };

  // ================= BUY PREMIUM =================

  const handleBuyPremium = () => {
    setShowPremium(false);
    navigate("/counselling-program");
  };

  return (

    <div className="admission-page">

      <h2>Admission Counselling</h2>

      <div className="admission-grid">

        {videos.map(video => (

          <VideoCard
            key={video.id}
            video={video}
            openVideo={openVideo}
          />

        ))}

      </div>

      {/* ================= PREMIUM POPUP ================= */}

      {showPremium && (
        <div className="modal-backdrop">
          <div className="modal">

            <h3>Premium Access Required</h3>

            <p>
              Enroll for Counselling Program to access this content.
            </p>

            <div className="modal-actions">

              <button onClick={() => setShowPremium(false)}>
                CANCEL
              </button>

              <button onClick={handleBuyPremium}>
                ENROLL NOW
              </button>

            </div>

          </div>
        </div>
      )}

    </div>

  );
};


// ================= VIDEO CARD =================

function VideoCard({ video, openVideo }) {

  const [showImage, setShowImage] = useState(true);

  return (

    <div
      className="admission-card"
      onClick={() => openVideo(video.videoUrl)}
    >

      <div className="thumb-box">

        {showImage && video.thumbnailUrl ? (

          <img
            src={video.thumbnailUrl}
            alt=""
            loading="lazy"
            onError={(e) => {
  e.target.onerror = null;
  e.target.src = "/fallback.jpg";
}}

          />

        ) : (

          <div className="text-thumb">
            {video.title}
          </div>

        )}

      </div>

      <div className="admission-title">
        {video.title}
      </div>

    </div>

  );
}

export default AdmissionVideos;
